import React, { Component, PropTypes } from 'react';
import Loading from 'dna-core/components/utils/elements/Loading.jsx';

export default class ButtonDefault extends Component {
	static propTypes = {
		type: PropTypes.string,
		id: PropTypes.string,
		name: PropTypes.string,
		isDisabled: PropTypes.bool,
		showDisabled: PropTypes.bool,
		handleClick: PropTypes.func,
		decoratorClass: PropTypes.string,
		buttonState: PropTypes.string,
		isButtonSmall: PropTypes.bool,
		qaSelector: PropTypes.string,
		children: React.PropTypes.any,
		intl: PropTypes.object, // GG.FrontEnd.DNA.react.intl
		accessibleIsLoadingText: PropTypes.string
	};
	static defaultProps = {
		type: 'button',
		decoratorClass: 'dna-button-brand',
		handleClick: () => {},
		isDisabled: false,
		showDisabled: true,
		buttonIsSmallVariant: false
	};
	handleClick(e) {
		e.preventDefault();
		const { buttonState } = this.props;
		if (buttonState === 'loading'){
			return;
		}
		this.props.handleClick(e);
	}
	render() {
		const {
			id,
			intl,
			type,
			children,
			showDisabled,
			qaSelector,
			buttonState,
			decoratorClass,
			isButtonSmall,
			name
		} = this.props;

		const isLoading = buttonState === 'loading';
		const isDisabled = this.props.isDisabled || isLoading;
		const accessibleIsLoadingText = buttonState === 'loading' && (this.props.accessibleIsLoadingText ? this.props.accessibleIsLoadingText : intl.formatMessage('content|_defaults|accessibleIsLoadingText'));
		const loadingClass = isButtonSmall ? 'dna-button-small-loading js-is-loading' : 'dna-button-loading js-is-loading';

		return (
			<button
				role="button"
				id={id}
				name={name || id}
				type={type}
				className={`${decoratorClass ? decoratorClass : ''} ${isButtonSmall ? 'dna-button-small' : ''} ${isLoading ? loadingClass : ''} ${!isLoading && showDisabled && isDisabled ? 'is-disabled' : ''}`}
				data-qa={qaSelector}
				onClick={::this.handleClick}
				disabled={isDisabled}
				aria-disabled={isDisabled}>
				{ isLoading &&
				<span>
					<span className="dna-button-text">
						{ children }
					</span>
					<Loading
						ariaHidden={!isLoading}
						className="dna-loading-button"
						accessibleText={accessibleIsLoadingText}
						qaSelector={`${qaSelector}-loading`} />
				</span>
				}
				{ !isLoading && children }
			</button>
		);
	}

}



// WEBPACK FOOTER //
// ../~/dna-button/components/button-default/ButtonDefault.jsx